import { User } from '@repo/domain/user';
import { HTC_DESIGNER_VISITED } from '@repo/editor/src/global/constants';
import { USER_ACCESS_TOKEN_KEY } from '@repo/transport/token';
import Cookies from 'js-cookie';

export const userVisitedEditor = (): boolean => {
  return !!Cookies.get(HTC_DESIGNER_VISITED);
};

export const hasUserAccessToken = (): boolean => {
  return !!Cookies.get(USER_ACCESS_TOKEN_KEY);
};

export const formatLargeNumber = (value: number): string | null => {
  if (typeof value !== 'number') {
    return null;
  }

  // a million
  if (value >= 1_000_000) {
    return `${Math.floor(value / 1_000_000)}M`;
  }

  // a thousand
  if (value >= 1000) {
    return `${Math.floor(value / 1000)}k`;
  }

  return `${value}`;
};

export const isUserLoggedOut = (user: User): boolean =>
  user === null || !hasUserAccessToken();

export const isNotNil = <T>(x: T | null | undefined): x is T =>
  x !== null && x !== undefined;
